import type { FC } from 'react';
import BatchActionLayout from './layouts/BatchActionLayout';
import SelectedLayout from './layouts/SelectedLayout';
import DefaultLayout from './layouts/DefaultLayout';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { BatchAction, StudioSection } from '../../types/store';
import { SelectionProps } from './types';

export interface Props extends SelectionProps {
  className?: string;
  activeSection: StudioSection;
  activeFolder?: any;
  batchAction?: BatchAction;
}

const StudioTableHeader: FC<Props> = ({ className, selectedCount, batchAction, ...rest }) => {
  const hasSelection = selectedCount > 0;
  let layout;

  if (batchAction) {
    layout = (
      <BatchActionLayout
        key={`batchAction-${batchAction}`}
        batchAction={batchAction}
        selectedCount={selectedCount}
        {...rest}
      />
    );
  } else if (hasSelection) {
    layout = <SelectedLayout selectedCount={selectedCount} {...rest} />;
  } else {
    layout = <DefaultLayout selectedCount={selectedCount} {...rest} />;
  }
  return (
    <BiLoggerContextProvider value={{ sectionname: 'studio-header' }}>
      <div className={className}>{layout}</div>
    </BiLoggerContextProvider>
  );
};
StudioTableHeader.displayName = 'StudioTableHeader';

export default StudioTableHeader;
